import React from 'react';
import { Typography } from 'antd';

const PaymentError = () => {
  return (
    <>
      <Typography.Title level={3} id="donate-message">
        Wystąpił błąd płatności.
      </Typography.Title>
      <Typography.Text>Sprawdź szczegóły w wiadomości email</Typography.Text>
    </>
  );
};

PaymentError.propTypes = {};

export default PaymentError;
